// Shared by the SPA and the build-time HTML generator.
export const SUPPORTED_LANGUAGES = ['en', 'zh', 'id', 'vi', 'pt', 'ja', 'th', 'es', 'it'];
export const languageFromPath = (pathname = '/') => {
  const segment = pathname.split('/').filter(Boolean)[0];
  return SUPPORTED_LANGUAGES.includes(segment) ? segment : 'en';
};
export const localePath = (language, path = '/') => `${language === 'en' ? '' : `/${language}`}${path === '/' && language !== 'en' ? '' : path}`;
export const pageFromPath = (pathname = '/') => {
  const parts = pathname.split('/').filter(Boolean);
  if (SUPPORTED_LANGUAGES.includes(parts[0])) parts.shift();
  return `/${parts.join('/')}`;
};
